import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./schedule-selector.component.html?ngResource";
import _ from 'lodash';
import { Component, inject, EventEmitter, Input, Output, } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import UserInfoService from '../../../../../components/base/infoServices/UserInfoService';
import { ScheduleManagerService } from '../../services/schedule-manager.service';
import { DialogService } from 'primeng/dynamicdialog';
import { ScheduleListComponent } from '../schedule-list/schedule-list.component';
let ScheduleSelectorComponent = class ScheduleSelectorComponent {
    org = '';
    schedule;
    label = 'Schedule';
    placeholder = 'Select a Schedule';
    displayEmpty = false;
    disabled;
    control;
    multiple = false;
    optionDisabledField;
    scheduleChange = new EventEmitter();
    schedules = [];
    showAdd = false;
    get link() {
        let url = '/admin/organizations/';
        if (this.org) {
            url = `${url}${this.org}/schedules/`;
            if (!this.multiple && this.schedule) {
                url = `${url}${this.schedule}`;
            }
        }
        return url;
    }
    ref;
    #destroy$ = new Subject();
    scheduleManager = inject(ScheduleManagerService);
    dialogService = inject(DialogService);
    userInfoService = inject(UserInfoService);
    ngOnInit() {
        this.showAdd = this.userInfoService.isCurrentUserAdmin();
        // if using the form control, listen for changes to update the schedule value
        // this way the link will be updated if the schedule is changed
        if (this.control?.valueChanges) {
            this.control.valueChanges.pipe(takeUntil(this.#destroy$)).subscribe((value) => {
                this.schedule = value;
            });
        }
        // if the control has a default value that is array like, set the multiple flag
        this.multiple = this.multiple || _.isArray(this.control?.defaultValue);
        this.org && this.loadSchedules();
    }
    ngOnDestroy() {
        this.#destroy$.next(null);
        this.#destroy$.complete();
    }
    ngOnChanges(changes) {
        if (changes.org && !changes.org.isFirstChange()) {
            this.loadSchedules();
        }
    }
    loadSchedules() {
        this.scheduleManager
            .getSchedules(this.org)
            .pipe(takeUntil(this.#destroy$))
            .subscribe((schedules) => {
            this.schedules = schedules;
        });
    }
    selectionChanged({ value }) {
        this.scheduleChange.emit(value);
    }
    selectionCleared() {
        if (this.control) {
            this.control.reset();
        }
        else {
            this.schedule = null;
        }
        this.scheduleChange.emit(this.schedule);
    }
    showSchedulesComponent() {
        this.ref = this.dialogService.open(ScheduleListComponent, {
            header: 'Edit Schedules',
            width: '90vw',
            height: '90vh',
            data: { org: this.org },
        });
        this.ref.onClose.subscribe(() => {
            this.loadSchedules();
        });
    }
    static propDecorators = {
        org: [{ type: Input }],
        schedule: [{ type: Input }],
        label: [{ type: Input }],
        placeholder: [{ type: Input }],
        displayEmpty: [{ type: Input }],
        disabled: [{ type: Input }],
        control: [{ type: Input }],
        multiple: [{ type: Input }],
        optionDisabledField: [{ type: Input }],
        scheduleChange: [{ type: Output }]
    };
};
ScheduleSelectorComponent = __decorate([
    Component({
        selector: 'schedule-selector',
        template: __NG_CLI_RESOURCE__0,
        standalone: true,
        imports: [CommonModule, FormsModule, DropdownModule, MultiSelectModule, ReactiveFormsModule],
        providers: [DialogService],
    })
], ScheduleSelectorComponent);
export { ScheduleSelectorComponent };
